import { BodyAuthComponents } from "../components/BodyAuth";
import { FormEvent, useEffect, useState } from "react";
import "./index.scss";
import { isEmailValid } from "../../../libs/validation-email";
import { postForgotPassword } from "../../../page/auth/service/service";
import { SuccessRecoverPassword } from "./success";
import { LostPassword } from "./lostPassword";
import { toastSuccess } from "../../../components/Toast";
import { Toaster } from "react-hot-toast";

type TypePage = "LOST" | "SUCCESS";

export const RecoverPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<{ status: boolean; message: string }>({ status: false, message: "" });
  const [page, setPage] = useState<TypePage>("LOST");

  const handleRecoverPassword = async () => {
    if (!isEmailValid(email)) {
      setError({ status: true, message: "Email inválido" });
      return;
    } else setError({ status: false, message: "" });
    const resRecoverPassword = await postForgotPassword({ email });
    if (resRecoverPassword?.ok) {
      toastSuccess("Email enviado com sucesso");
      if (page === "LOST") setPage("SUCCESS");
      return;
    }
    return setError({ status: true, message: "E-mail inválido" });
  };

  return (
    <>
      <Toaster position="top-left" />
      <BodyAuthComponents className="flex flex-col justify-center items-center gap-12">
        {page === "LOST" && (
          <LostPassword handleRecoverPassword={handleRecoverPassword} email={email} setEmail={setEmail} error={error} setError={setError} />
        )}
        {page === "SUCCESS" && <SuccessRecoverPassword email={email} handleRecoverPassword={handleRecoverPassword} />}
      </BodyAuthComponents>
    </>
  );
};
